import React, { useEffect } from 'react';
const FORM_ID = 'MpGPMx8N2yjiJ8DZbGKO';
const FORM_NAME = 'Join Recruiting Page Submission';
const EMBED_SCRIPT = 'https://link.msgsndr.com/js/form_embed.js';

/** LeadConnector (GoHighLevel) inline form. The embed script auto-sizes the iframe. */
export function GhlFormEmbed() {
  useEffect(() => {
    if (!document.querySelector(`script[src="${EMBED_SCRIPT}"]`)) {
      const script = document.createElement('script');
      script.src = EMBED_SCRIPT;
      script.async = true;
      document.body.appendChild(script);
    }

    // The Meta `Lead` conversion fires on /thank-you, where GHL redirects after
    // submission, so nothing is tracked here to avoid counting a lead twice.
  }, []);
  return <div className="overflow-hidden rounded-2xl bg-white p-2 md:p-3" data-id="element-140" data-mp="1yjb04o4v1ezy">
      <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} id={`inline-${FORM_ID}`} title={FORM_NAME} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name={FORM_NAME} data-height="undefined" data-layout-iframe-id={`inline-${FORM_ID}`} data-form-id={FORM_ID} data-cookie-consent="true" data-cookie-consent-provider="auto" className="h-[760px] w-full border-none sm:h-[700px]" data-id="element-141" data-mp="2vzzzmb6c8566" />
    </div>;
}